/**
 * Whether a restaurant session-type list (First Table or walk-in) includes
 * the store filter session. API values are lowercase (`dinner`, `dinner2`).
 */
export default function hasSessionTypeForFilter(
  sessionTypes: readonly (string | null)[] | null | undefined,
  session: SessionType,
) {
  return (sessionTypes || []).some(
    (sessionType) =>
      sessionType && sessionType.includes(session.toLocaleLowerCase()),
  );
}
